<footer class="footer not-printable">
  <span class="info">
   {{(currentUser$ | async)?.firstName}}  | {{companyName}} |  <a [href]="'/log-changes'" target="_blank" rel="noopener">
    {{ environment.VERSION }}
  </a>
   | <a routerLink="/share-form">Share form</a>
   | <a routerLink="/audit-logs">Audit log</a>
   | <a routerLink="/global-requests">Global requests</a><!--
        The count is tickets waiting on this user. Rendered only when non-zero: a "0" badge is noise on
        every screen, and the point of the badge is that it means something when it appears.
     --><a *ngIf="ticketsNeedingInput() > 0"
          routerLink="/global-requests/tickets"
          class="tickets-badge"
          [attr.aria-label]="ticketsNeedingInput() + ' ticket(s) need your input'">{{ ticketsNeedingInput() }}</a>
   <ng-container *ngxPermissionsOnly="['CorporateAdmin']">
     | <a routerLink="/admin/pending-changes">Pending changes</a>
   </ng-container>
   | <a href="javascript:void(0)" (click)="openCyprusRegistrySearch()">Cyprus registry search</a>
  </span>
</footer>
